import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReadonlyNumberField from '../fields/ReadonlyNumberField';
import { bidsType } from '../../types';

AutomaticallyCancelledBidsField.propTypes = {
    automaticallyCancelledBidsForMember: bidsType.isRequired,
    onShowTable: PropTypes.func.isRequired,
};

function AutomaticallyCancelledBidsField(props) {
    const {
        automaticallyCancelledBidsForMember,
        onShowTable,
    } = props;
    const { t } = useTranslation();
    return (
        <ReadonlyNumberField
            label={t('auctions.bids-list.automatically-cancelled-bids')}
            value={automaticallyCancelledBidsForMember.length}
            className="auction-bids--bid-overview--container--automatically-cancelled-bids"
            postfix={automaticallyCancelledBidsForMember.length ? (
                <>
                    &nbsp;
                    &nbsp;
                    <button
                        type="button"
                        className="show-automatically-cancelled-bids-button button button-without-border"
                        onClick={onShowTable}
                        title={t('auctions.bids-list.show-automatically-cancelled-bids-table')}
                        aria-label={t('auctions.bids-list.show-automatically-cancelled-bids-table')}
                    >
                        <FontAwesomeIcon icon="search" />
                    </button>
                </>
            ) : ''}
        />
    );
}

export default AutomaticallyCancelledBidsField;
